import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBIcon,
} from "mdb-react-ui-kit";
import SilverPlanCard from "./SilverPlanCard";
import GoldPlanCard from "./GoldPlanCard";
import PlatinumPlanCard from "./PlatinumPlanCard";

const PelvicSensePaidPlansCards = ({ width }) => {
  return (
    <>
      <MDBRow className={width > 767 ? "py-5" : width > 540 ? "p-5" : "py-5"}>
        <MDBCol className={width <= 767 && "mb-3"} sm="12" md="4" lg="4">
          <SilverPlanCard width={width} />
        </MDBCol>
        <MDBCol className={width <= 767 && "mb-3"} sm="12" md="4" lg="4">
          <GoldPlanCard width={width} />
        </MDBCol>
        <MDBCol className={width <= 767 && "mb-3"} sm="12" md="4" lg="4">
          <PlatinumPlanCard width={width} />
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default PelvicSensePaidPlansCards;
